import { siteMetadata, validateAreaParams } from 'config'
import { fetchFeather } from './fetch'

const { apiHost } = siteMetadata

/**
 * Fetch list of risk models and risk node results for this area, reporting units type, and compare area combination
 * @param {String} reportingUnits - one of census_tracts, counties
 * @param {String} compareArea - one of by_state, by_county, by_place_county, conus (depends on areaType and reportingUnits)
 * @param {String} areaType - one of states, counties, places
 * @param {String} areaId - state, county, or place ID
 * @returns
 */
export const fetchModelListResults = (
  reportingUnits,
  compareArea,
  areaType,
  areaId
) => {
  if (!validateAreaParams(reportingUnits, areaType, compareArea)) {
    // will show as 404 error with error message already logged to console
    return null
  }

  const url = `${apiHost}/api/v1/internal/results/${reportingUnits}/${compareArea}/${areaType}/${areaId}`
  return fetchFeather(url)
}

/**
 * Fetch top-level node results for a model
 * @param {String} reportingUnits - one of census_tracts, counties
 * @param {String} compareArea - one of by_state, by_county, by_place_county, conus (depends on areaType and reportingUnits)
 * @param {String} areaType - one of states, counties, places
 * @param {String} areaId - state, county, or place ID
 * @param {*} modelId - model ID
 * @returns
 */
export const fetchModelSummaryResults = (
  reportingUnits,
  compareArea,
  areaType,
  areaId,
  modelId
) => {
  if (!validateAreaParams(reportingUnits, areaType, compareArea)) {
    // will show as 404 error with error message already logged to console
    return null
  }

  const url = `${apiHost}/api/v1/internal/results/${reportingUnits}/${compareArea}/${areaType}/${areaId}/${modelId}/summary`
  return fetchFeather(url)
}

/**
 * Fetch risk subtree results for this state/county/place, model, census_tracts/counties, compare area combination
 * @param {String} reportingUnits - one of census_tracts, counties
 * @param {String} compareArea - one of by_place, by_county_place, by_state, conus (depends on reportingUnits)
 * @param {String} areaType - one of states, counties, places
 * @param {String} areaId - state, county, or place ID
 * @param {String} modelId - model ID
 * @param {String} subtreeId - 'risk' or intervention ID
 * @returns
 */
export const fetchModelSubtreeResults = (
  reportingUnits,
  compareArea,
  areaType,
  areaId,
  modelId,
  subtreeId
) => {
  validateAreaParams(reportingUnits, areaType, compareArea)

  const url = `${apiHost}/api/v1/internal/results/${reportingUnits}/${compareArea}/${areaType}/${areaId}/${modelId}/details/${subtreeId}`
  return fetchFeather(url)
}

export const fetchCountyCompareResults = (countyId, modelId) => {
  const url = `${apiHost}/api/v1/internal/compare/counties/${countyId}/${modelId}`

  return fetchFeather(url)
}
